import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { faqs } from "../../data/faq";
import { desserts } from "../../data/images";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream py-20 lg:py-28" data-id="element-144" data-mp="uraywmkpgc0b">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-145" data-mp="70yh8jznr0wj">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-146" data-mp="22562y7uflzj">
          <Reveal data-id="element-147" data-mp="23omcoti1x1b">
            <h2 className="font-display text-3xl font-bold leading-tight text-cocoa sm:text-5xl" data-id="element-148" data-mp="24815wnus5b4">Preguntas Que Probablemente Tienes</h2>
            <p className="mt-3 font-script text-3xl text-berry" data-id="element-149" data-mp="bzrx2j2f33zv">(respondidas)</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-8 hidden lg:block" data-id="element-150" data-mp="1se1l1c2qyqq6">
            <img src={desserts.mintCookies} alt="Galletas de chocolate y menta del pack" className="aspect-[4/5] w-full rounded-[2rem] object-cover shadow-xl ring-8 ring-white" data-id="element-151" data-mp="1sge2lo4lez2p" />
          </Reveal>
        </div>

        <ul className="space-y-3" data-id="element-152" data-mp="mstxz4aa5i9u">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={f.q} delay={i * 0.03} data-id="element-153" data-mp="rrndf294njcn" data-mpi={i}>
                <li className={`rounded-2xl bg-white shadow-[0_12px_30px_-24px_rgba(59,34,25,0.6)] ring-1 transition-colors duration-150 ${isOpen ? "ring-berry/30" : "ring-blush"}`} data-id="element-154" data-mp="rpst9q5ojv9m">
                  <h3 data-id="element-155" data-mp="3vagnh52p5q22">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 p-5 text-left sm:p-6" data-id="element-156" data-mp="3v6sv498zn9ox">
                      <span className="text-lg font-semibold leading-snug text-cocoa" data-id="element-157" data-mp="cwh86hhuvokd">{f.q}</span>
                      <motion.span animate={{
                    rotate: isOpen ? 45 : 0
                  }} transition={{
                    duration: 0.2,
                    ease: [0.23, 1, 0.32, 1]
                  }} className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${isOpen ? "bg-berry text-white" : "bg-blush-light text-cocoa"}`} data-id="element-158" data-mp="3cgbc4wdyjsgr">
                        <PlusIcon className="h-4 w-4" data-id="element-159" data-mp="xeizyff6w4t0" />
                      </motion.span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-160" data-mp="4qdf7so4yft6">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: "auto",
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-161" data-mp="4s7xez80vttk">
                        <p className="border-l-4 border-leaf mx-5 mb-6 pl-4 leading-relaxed text-cocoa-light sm:mx-6" data-id="element-162" data-mp="1p4f2e7ryywc6">{f.a}</p>
                      </motion.div>}
                  </AnimatePresence>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}